import Intake from './List';
import IntakeProfile from './intakeProfile';

export { IntakeProfile };
export default Intake;
